<template>
  <div>
    <div class="pt-2 d-flex not-selectable">
      <div class="px-3">
        <span class="shutdown-alert-title"
          >Alertas de previsão de interrupções</span
        >
      </div>
      <v-spacer></v-spacer>
      <div class="pr-2">
        <v-tooltip
          max-width="200"
          bottom
          content-class="arrow tooltip-bottom"
          color="secondary lighten-3"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" color="primary"
              >icon-alertadis-info-circle</v-icon
            >
          </template>
          <span style="width: 50px"
            >Você será notificado quando houver municípios com previsão de
            interrupções a partir de 5000 unidades consumidoras nas próximas 3 horas,
            de acordo com as regiões, agências ou municípios favoritados em seu perfil.</span
          >
        </v-tooltip>
      </div>
    </div>
    <div v-if="!hasNotifications">
      <div class="d-flex ma-2 pa-1 no-notification-card not-selectable">
        <div>
          <v-icon color="primary">icon-alertadis-info-circle</v-icon>
        </div>
        <div class="pl-2 d-flex flex-column">
          <span class="no-notification-card-title"> Nenhum alerta </span>
          <span class="pt-2 no-notification-card-text">
            Não há previsões de 5000 ou mais unidades consumidoras interrompidas
            nas próximas 3 horas nas regiões, agências ou municípios favoritados.
          </span>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="dailyInterruptionsNotificationsCoutiesData">
        <div
          class="mx-4 pa-0 pt-2"
          v-for="(countie, c) in dailyInterruptionsNotificationsCoutiesData"
          :key="c"
        >
          <div class="pt-2 alert-type">MUNICÍPIO</div>
          <div class="alert-local">{{ countie.locationName }}</div>
          <v-row no-gutters class="d-flex flex-column">
            <div class="pt-4 d-flex align-center">
              <div
                class="px-2"
                :class="getAlertChipClass(countie)"
              >
                {{ alertType(countie.result) }}
              </div>
            </div>
            <div class="pt-3">
              <span class="interruption-qtd-countie">
                Previsão de consumidor interrompido:
                <b>{{ interruptionQtd(countie) }}</b>
              </span>
            </div>
          </v-row>
          <div class="pt-4 alert-forecast">
            PREVISÃO PARA {{ moment(countie.date).format("DD/MM/YYYY") }}
          </div>
          <v-row no-gutters class="pt-2 pb-4 d-flex align-center">
            <v-icon size="14" color="accent lighten-1"
              >icon-alertadis-angle-double-right</v-icon
            >
            <a class="pl-2 alert-details" @click="goToForecastTableDetailsByCountieInAgency(countie)">Detalhar alerta</a>
          </v-row>
          <v-divider class="pb-2"></v-divider>
        </div>
      </div>
      <div v-if="dailyInterruptionsNotificationsAgencyData">
        <div
          class="mx-4 pa-0 pt-1"
          v-for="(agency, j) in dailyInterruptionsNotificationsAgencyData"
          :key="j"
        >
          <div class="pt-2 alert-type">Base de Serviço de Campo</div>
          <div class="alert-local">{{ agency.agencyIds[0] }}</div>
          <div class="alert-total-cities">
            {{ agency.data.length }} município(s) com interrupção
          </div>
          <div class="pt-4 alert-forecast">
            PREVISÃO PARA {{ moment(agency.data[0].date).format("DD/MM/YYYY") }}
          </div>
          <v-row no-gutters class="pt-2 pb-4 d-flex align-center">
            <v-icon size="14" color="accent lighten-1"
              >icon-alertadis-angle-double-right</v-icon
            >
            <a
              class="pl-2 alert-details"
              @click="goToForecastTableDetailsByAgency(agency)"
              >Detalhar alerta</a
            >
          </v-row>
          <v-divider class="pb-2"></v-divider>
        </div>
      </div>
      <div v-if="dailyInterruptionsNotificationsRegionalData">
        <div
          class="mx-4 pa-0 pt-2"
          v-for="(regional, i) in dailyInterruptionsNotificationsRegionalData"
          :key="i"
        >
          <div class="pt-2 alert-type">REGIONAL</div>
          <div class="alert-local">{{ regional.fullname }}</div>
          <div class="alert-total-cities">
            {{ regional.data.length }} município(s) com interrupção
          </div>
          <div class="pt-2 d-flex align-center max-estimated-section">
            <span class="max-estimated-label">Máximo estimado nas próximas 3h:</span>
            <span class="max-estimated-value">
              {{ formatMaxInterruptionUnits(regional.fullname) }}
            </span>
          </div>
          <div class="pt-4 alert-forecast">
            PREVISÃO PARA
            {{ moment(regional.data[0].date).format("DD/MM/YYYY") }}
          </div>
          <v-row no-gutters class="pt-2 pb-4 d-flex align-center">
            <v-icon size="14" color="accent lighten-1"
              >icon-alertadis-angle-double-right</v-icon
            >
            <a
              class="pl-2 alert-details"
              @click="goToForecastTableDetails(regional.fullname)"
              >Detalhar alerta</a
            >
          </v-row>
          <v-divider class="pb-2"></v-divider>
        </div>
      </div>
    </div>
    <v-dialog v-model="forecastCountiesModal" max-width="1100" persistent>
      <v-card>
        <forecast-counties
          :filter="filterForDetails"
          :nameCountie="nameCountieAgencyTable"
          :openedDialog="openedDialog"
          @closeForecastTableDialog="closeForecastTableDialog"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ForecastCountiesNav from "./ForecastCountiesNav.vue";

export default {
  components: {
    "forecast-counties": ForecastCountiesNav,
  },
  data: () => ({
    isProduction: process.env.NODE_ENV === "production",
    forecastCountiesModal: false,
    filterForDetails: {},
    nameCountieAgencyTable: "",
    openedDialog: false,
  }),

  methods: {
    alertType() {
      return "ALERTA";
    },
    getAlertChipClass() {
      return 'high-chip';
    },
    interruptionQtd(countie) {
      const units = parseInt(countie.qtdeuc) || 0;
      return `${new Intl.NumberFormat('pt-BR').format(units)} unidades consumidoras`;
    },
    formatMaxInterruptionUnits(regionalName) {
      // O max3h já foi calculado no store para cada regional
      const notifications = this.dailyInterruptionsNotificationsRegionalData;

      if (notifications && notifications.length > 0) {
        const regionalData = notifications.find(r => r.fullname === regionalName);
        if (regionalData && regionalData.max3h !== undefined) {
          return new Intl.NumberFormat('pt-BR').format(regionalData.max3h);
        }
      }

      return '0';
    },
    closeForecastTableDialog(value) {
      this.forecastCountiesModal = value;
      this.nameCountieAgencyTable = "";
      this.openedDialog = value;
    },
    goToForecastTableDetails(regional) {
      const obj = {
        regional: regional,
      };
      this.filterForDetails = obj;
      this.forecastCountiesModal = true;
      this.openedDialog = !this.openedDialog;
    },
    goToForecastTableDetailsByAgency(item) {
      if (item.agencyIds[0] == "AGCTC,AGCTS") {
        item.agencyIds[0] = "AGCTC";
      }
      this.filterForDetails = {
        agency: item.agencyIds[0],
        regionalByAgency: item.data[0].regional,
      };
      this.forecastCountiesModal = true;
      this.openedDialog = !this.openedDialog;
    },
    goToForecastTableDetailsByCountieInAgency(item) {
      if (item.agencyIds[0] == "AGCTC,AGCTS") {
        item.agencyIds[0] = "AGCTC";
      }
      this.filterForDetails = {
        agency: item.agencyIds[0],
        regionalByAgencyByCity: item.regional,
      };
      this.nameCountieAgencyTable = item.locationName
      this.forecastCountiesModal = true;
      this.openedDialog = !this.openedDialog;
    },
  },
  computed: {
    ...mapGetters([
      "dailyInterruptionsNotificationsRegionalData",
      "dailyInterruptionsNotificationsAgencyData",
      "dailyInterruptionsNotificationsCoutiesData",
    ]),
    hasNotifications() {
      if (
        this.dailyInterruptionsNotificationsRegionalData.length > 0 ||
        this.dailyInterruptionsNotificationsAgencyData.length > 0 ||
        this.dailyInterruptionsNotificationsCoutiesData.length > 0
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.shutdown-alert-title {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: 0.15px;
  color: var(--v-primary-base);
}

.alert-date {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--v-primary-darken2);
}
.alert-type {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.4px;
  color: var(--v-primary-darken2);
}
.alert-local {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: 0.15px;
  color: var(--v-primary-base);
}
.alert-total-cities {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.5px;
  color: var(--v-primary-base);
}
.alert-grade-text {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.4px;
  color: var(--v-primary-darken2);
}
.alert-grade-value {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--v-primary-base);
}
.alert-details {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-accent-lighten1);
}
.alert-forecast {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--v-highlight80-base);
}

.high-chip {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  border: 1px solid var(--v-highAlert-base);
  border-radius: 4px;
  color: var(--v-highAlert-base);
  background-color: rgba(135, 101, 212, 0.16);
}

.interruption-qtd-countie {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-base);
}

.tooltip-bottom::before {
  border-right: solid 6px transparent;
  border-left: solid 6px transparent;
  transform: translateX(-50%);
  position: absolute;
  z-index: -21;
  content: "";
  bottom: 100%;
  left: 50%;
  height: 0;
  width: 0;
}

.tooltip-bottom.arrow::before {
  border-bottom: solid 6px var(--v-secondary-lighten3) !important;
}

.no-notification-card {
  background-color: rgba(25, 28, 41, 1);
  border-radius: 8px;
}
.no-notification-card-title {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-base);
}
.no-notification-card-text {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-base);
}

.not-selectable {
  -webkit-touch-callout: none; /* iPhone OS, Safari */
  -webkit-user-select: none; /* Chrome, Safari 3 */
  -khtml-user-select: none; /* Safari 2 */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+ */
  user-select: none; /* Possível implementação no futuro */
}

.max-estimated-section {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
}

.max-estimated-label {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--v-primary-darken2);
}

.max-estimated-value {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-base);
}

/* .progress {
  height: 4px;
  border-radius: 2px;
  width: 100%;
  background-image:
   linear-gradient(red, red),
    linear-gradient(blue, blue),
    linear-gradient(green, green),
    linear-gradient(green, green),
     linear-gradient(yellow, yellow);
  background-size: 4% 100%, 50% 100%, 60% 100%, 100% 100%;
  background-repeat: no-repeat;
} */
</style>